import { COMMUNITY_API } from 'modules/commutinies/api/community-api'
import { CommunityInterface } from 'modules/commutinies/types/community-interface'
import { RequestModuleEnum } from 'shared/enums/request-module-enum'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export function useCommunities(shouldFetch = true) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, CommunityInterface[]>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr(
    [COMMUNITY_API, RequestModuleEnum.Community],
    fetcher,
    undefined,
    shouldFetch && !!user,
  )
}
